class LocalDataService {
  setDefaultBp(kapid_id, bp_id, bp_br_id) {
    let defaultbp = JSON.parse(localStorage.getItem("defaultbp"));
    defaultbp = {
      ...defaultbp,
      [kapid_id]: { bp_id: bp_id, bp_br_id: bp_br_id },
    };
    localStorage.setItem("defaultbp", JSON.stringify(defaultbp));
  }

  getDefaultBp(kapid_id = undefined) {
    if (kapid_id === undefined) {
      kapid_id = this.getCurrentUser();
    }
    if (!kapid_id) {
      return { bp_id: 0, bp_br_id: 0 };
    }
    let defaultbp = JSON.parse(localStorage.getItem("defaultbp"));
    if (!defaultbp) return { bp_id: 0, bp_br_id: 0 };
    return defaultbp[kapid_id] === undefined
      ? { bp_id: 0, bp_br_id: 0 }
      : defaultbp[kapid_id];
  }
  setCurrentUser(kapid_id) {
    localStorage.setItem("_cu", kapid_id);
  }
  getCurrentUser() {
    return localStorage.getItem("_cu");
  }
  setRecentKapidUserSearch(data, page) {
    let _cu = this.getCurrentUser();
    const key = `_rs_${_cu}_${page}`;
    let searches = JSON.parse(localStorage.getItem(key));
    searches = searches ? searches : [];
    // const kapidExists = searches.some((item) => item.kapid_id === data.id);
    const existingIndex = searches.findIndex(
      (item) => item.kapid_id === data.id
    );
    if (existingIndex !== -1) {
      searches[existingIndex].timestamp = Date.now();
    } else {
      // Step 1: Push new data into the list
      searches.push({
        full_name: data.full_name,
        kapid_id: data.id,
        timestamp: Date.now(),
      });
    }

    searches.sort((a, b) => b.timestamp - a.timestamp);
    searches = searches.slice(0, 5);
    localStorage.setItem(key, JSON.stringify(searches));
  }
  getRecentKapidUserSearch(page) {
    let _cu = this.getCurrentUser();
    const key = `_rs_${_cu}_${page.toLowerCase()}`;
    let searches = JSON.parse(localStorage.getItem(key));
    searches = searches ? searches : [];
    return searches;
  }
}

export default new LocalDataService();
